import { AxiosResponse } from "axios";
import { all, call, put, takeEvery } from "redux-saga/effects";
import api from "../../api";
import Endpoint from "../../shared/endpoints";
import clientFailedSharesConstants from "../constants/clientFailedSharesConstants";

const getClientFailedShares = (payload: any) => {
    const url = Endpoint.getClientFailedShares.replace("{clientId}", payload.clientId);
    return api.get(url);
};

function* getClientFailedSharesSaga(action: any) {
    try {
        const response: AxiosResponse = yield call(getClientFailedShares, action.payload);
        yield put({
            type: clientFailedSharesConstants.GET_CLIENT_FAILED_SHARES_SUCCESS,
            payload: response.data,
        });
    } catch (error) {
        yield put({
            type: clientFailedSharesConstants.GET_CLIENT_FAILED_SHARES_FAILURE,
            payload: error,
        });
    }
}

function* clientFailedSharesSaga() {
    yield all([
        takeEvery(
            clientFailedSharesConstants.GET_CLIENT_FAILED_SHARES_REQUEST,
            getClientFailedSharesSaga,
        ),
    ]);
}

export default clientFailedSharesSaga;
